module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/3-5f0a320faddfce2bf57c70d9ce8534aa.jpg";